import { MomentumRing } from './MomentumRing';
import { THICK_TILE_STYLE, THICK_TILE_CLASSNAME } from './tileStyles';

interface ContinueLearningBannerProps {
  title: string;
  completed: number;
  total: number;
  estimatedTimeLeft: string;
  onContinue: () => void;
}

export function ContinueLearningBanner({
  title, completed, total, estimatedTimeLeft, onContinue,
}: ContinueLearningBannerProps) {
  return (
    <div
      className={`${THICK_TILE_CLASSNAME} h-full flex items-center justify-between`}
      style={{ ...THICK_TILE_STYLE, padding: '16px 22px' }}
    >
      {/* Right edge glow */}
      <div className="absolute right-0 top-0 bottom-0 w-40 pointer-events-none" style={{ background: 'linear-gradient(90deg, transparent, rgba(108,92,231,0.04))' }} />

      <div className="flex items-center gap-3.5">
        <MomentumRing done={completed} total={total} />
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-wider text-indigo-500 mb-0.5">Continue Learning</div>
          <div className="font-heading text-sm font-semibold text-white">{title}</div>
          <div className="text-xs text-content-dim mt-0.5">{completed} of {total} sections &middot; {estimatedTimeLeft} remaining</div>
        </div>
      </div>

      <button
        onClick={onContinue}
        className="bg-indigo-500 text-white border-none rounded-lg font-semibold text-[13px] cursor-pointer font-body flex items-center gap-1.5"
        style={{ padding: '9px 18px', boxShadow: '0 3px 14px rgba(108,92,231,0.25)' }}
      >
        &#9654; Continue
      </button>
    </div>
  );
}
